import {Injectable, OnInit} from '@angular/core';
import {DataService} from './dataIcar.service';
import {StateIcar} from '../../interfaces/scripts';
import {Subject} from 'rxjs';
import {StorageService} from '../storage.service';


declare var IcarSDK: any;

@Injectable()
export class IcarVisionService {

  constructor(private data: DataService , private storage: StorageService) {
  }

  private tipo = null;
  public $IcarServiceState: Subject<any> = new Subject<string>();

  private contBlurring = 0;
  private maxcontadorBlurring: number = 4;
  private currentBlurring: number = 1;

  private manualSet = null;
  private frontManual: boolean = false;
  private backManual: boolean = false;

  startVideo(videoInput, tipo) {

    this.tipo = tipo;

    this.documentConfig(videoInput);
    this.setManual();
  }

  startVideoPassaport(videoInput, tipo) {

    this.tipo = tipo;

    this.documentConfig(videoInput);
    this.setManual();
  }

  setManual() {

    if (this.manualSet != null) {
      window.clearInterval(this.manualSet);
    }

    this.manualSet = setTimeout(() => {
      (this.tipo === 'FRONT') ? this.frontManual = true : this.backManual = true;
      this.$IcarServiceState.next(StateIcar.MANUAL_TRIGER);
    }, 2500);

  }

  capturaManual() {
    IcarSDK.documentCapture.manualTrigger();
  }

  documentConfig(videoInput) {

    let OPTIONS_DOCUMENTS = {
      type_document: IcarSDK.TYPE_DOC.IDCARD,
      messageFpsFunction: this.msgFramesFunction,
      messageFeedbackFunction: this.messageDocCaptureFeedback.bind(this),
      MAX_ATTEMPTS: -1,
      fontText: 'bold 50px Arial',
      colorText: '#c91f28',
      multiplicationFactorBlurring: this.currentBlurring
      // 1 min 1.5 max
    };

    var OPTIONS_VIDEO = {
      modeCapture: IcarSDK.MODE_CAPTURE.DOCUMENT_IDCARD,
      callBackFeedBackFunction: this.onFeedBackCallBack.bind(this)
    };

    IcarSDK.video.initialize(videoInput, OPTIONS_VIDEO);
    //IcarSDK.video.getNumberOfCameras(this.onNumCamsReceivedCallback);


    IcarSDK.documentCapture.create(videoInput, this.requestFrameCallback, this.onDocumentResultCallback.bind(this), OPTIONS_DOCUMENTS);

  }

  faceConfig(videoInput) {

    const OPTIONS_FACE_CAPTURE = {
      pathImages: 'assets/img/',
      initial_zIndex: 10,
    };

    IcarSDK.faceCapture.create(videoInput, this.requestFrameCallback, this.onDocumentResultCallback.bind(this), OPTIONS_FACE_CAPTURE);

  }

  onFeedBackCallBack(resultFeedBack) {
    console.log('onFeedBackCallBackonFeedBackCallBack');
    switch (resultFeedBack) {
      case IcarSDK.RESULT_VIDEO.OK:
        // inicializamos la captura;
        IcarSDK.video.getListOfCameras(this.onListCamsReceivedCallback.bind(this));
        //IcarSDK.documentCapture.start();

        break;
      case IcarSDK.RESULT_VIDEO.NO_CAMERA_DEVICES:
        this.$IcarServiceState.next(StateIcar.NO_CAMERA_DEVICES);
        break;
      case IcarSDK.RESULT_VIDEO.NO_CAMERA_PERMISSION:
        this.$IcarServiceState.next(StateIcar.NO_CAMERA_PERMISSION);
        break;
      case IcarSDK.RESULT_VIDEO.UNAVAILABLE_CAMERA:
        this.$IcarServiceState.next(StateIcar.UNAVAILABLE_CAMERA);

        break;
      case IcarSDK.RESULT_VIDEO.UNSUPPORTED_BROWSER:
        this.$IcarServiceState.next(StateIcar.UNSUPPORTED_BROWSER);
        break;
      case IcarSDK.RESULT_VIDEO.UNKNOWN_ERROR:
        this.$IcarServiceState.next(StateIcar.UNKNOWN_ERROR);
        break;
    }
  }

  onListCamsReceivedCallback(listCams) {
    var selectedCameraIndex = 0;//default

    if (listCams.length > 2) {
      listCams.forEach(function(camera) {
        //intentamos buscar cámara principal
        if (camera.label === 'camera2 0, facing back') {
          selectedCameraIndex = camera.cameraIndex;
        }
      });
      if (selectedCameraIndex != 0) {
        IcarSDK.video.changeCamera(selectedCameraIndex);
      }
    }
    IcarSDK.documentCapture.start();
    this.$IcarServiceState.next(StateIcar.OK);
  }

  public endVideo() {
    console.log('endVideoendVideoendVideo');
    IcarSDK.documentCapture.stop();
    setTimeout(
      function() {
        IcarSDK.video.cleanUp();
      },
      500
    );
  }

  // Funciones para capturar video y guardar la imagen en imageResult
  requestFrameCallback(onFrameReceivedCallback) {
    IcarSDK.video.requestFrame(onFrameReceivedCallback);
  }

  onDocumentResultCallback(answerResult, modeCapture, imageResult, roiPoints, hashCode) {

    //console.log('answer', answerResult);

    if (answerResult === IcarSDK.ResultProcess.OK) {

      const newCanvas = document.createElement('canvas');
      newCanvas.width = imageResult.width;
      newCanvas.height = imageResult.height;
      newCanvas.getContext('2d').putImageData(imageResult, 0, 0);

      // Estos son los datos a enviar al servicio
      const dataToBeSent: string = newCanvas.toDataURL('image/jpeg');

      // guardamos los datos en el servicio

      console.log("dataToBeSent");
      console.log(dataToBeSent);



      this.storage.saveToStorage('imagenAdelente',dataToBeSent.replace('data:image/jpeg;base64,', ''));

      // finalizamos el proceso
      this.endVideo();

      // enviamos a la vista
      this.$IcarServiceState.next(StateIcar.RESULT_OK);


    } else {
      // error en el resultado
      this.$IcarServiceState.next(StateIcar.RESULT_KO);
    }

  }

  startFace() {
    IcarSDK.faceCapture.start();
  }

  msgFramesFunction(textInfo) {
    //document.getElementById("fps_message").innerHTML = textInfo;
  }

  messageDocCaptureFeedback(messageDC) {
    /*
      We recieve info about the process.
      'messageDC' contains 2 attributes: CODE and TEXT:
      1 : POOR SYSTEM 			-> The device used is a poor system
      2 : NO MOVEMENT DETECTED 	-> There isn't detected movement
      3 : DARK 					-> The document is too dark
      4 : BLURRED 				-> The document is blurred
    */
    var message_code = messageDC.CODE;

    if (messageDC.CODE == 4 && this.contBlurring >= 0) {
      this.contBlurring++;
      if (this.contBlurring >= this.maxcontadorBlurring) {
        if (this.currentBlurring > 1.5) {
          this.currentBlurring = -1; //Disable MFB
        } else {
          this.currentBlurring += 0.2;
        }
        this.contBlurring = 0;

        let OPTIONS_DOCUMENTS = {
          type_document: IcarSDK.TYPE_DOC.IDCARD,
          messageFpsFunction: this.msgFramesFunction,
          messageFeedbackFunction: this.messageDocCaptureFeedback.bind(this),
          MAX_ATTEMPTS: -1,
          fontText: 'bold 50px Arial',
          colorText: '#c91f28',
          multiplicationFactorBlurring: this.currentBlurring
          // 1 min 1.5 max
        };
        // actualizamos recargamos elas opciones del sdk
        IcarSDK.documentCapture.reloadOptions(OPTIONS_DOCUMENTS);
        console.log('Current MFB: ' + this.currentBlurring);
      }
    }
  }

  // function to do the request of the frame to the video
  //'onFrameReceivedCallback' must to be the next parameters:
  // - imageData: frame of the video
}





